import { PlayCircleIcon } from "@heroicons/react/24/solid";

interface QueryButtonProp {
  buttonText?: any;
  type?: any;
  className?: any;
  disabled?: any;
  onClick?: any;
}

const QueryButton: React.FC<QueryButtonProp> = ({
  buttonText = "",
  type,
  className = "",
  disabled = false,
  onClick,
}) => {
  return (
    <button
      disabled={disabled}
      type={type}
      onClick={onClick}
      className={`hover:scale-90 transition duration-500 flex items-center shadow-md text-xs 
      font-semibold text-white justify-center gap-x-1 rounded-full ml-auto bg-secondary px-3 
      py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary
      focus:ring-opacity-70 ${className}
      ${disabled && "cursor-not-allowed opacity-50"}`}
    >
      <PlayCircleIcon className="h-4 w-4" />

      <div className="-mt-auto">{buttonText}</div>
    </button>
  );
};
export default QueryButton;
